const APP = 'fulcrum/containers/App/App'
const TOGGLE_NAVIGATION_DRAWER = 'fulcrum/containers/App/TOGGLE_NAVIGATION_DRAWER'
const APP_PAGE_MOUNT = 'fulcrum/containers/App/APP_PAGE_MOUNT'
const APP_PAGE_UNMOUNT = 'fulcrum/containers/App/APP_PAGE_UNMOUNT'

const FETCH_USER_PROFILE = 'fulcrum/containers/App/FETCH_USER_PROFILE'
const FETCH_USER_PROFILE_START = 'fulcrum/containers/App/FETCH_USER_PROFILE_START'
const FETCH_USER_PROFILE_SUCCESS = 'fulcrum/containers/App/FETCH_USER_PROFILE_SUCCESS'
const FETCH_USER_PROFILE_ERROR = 'fulcrum/containers/App/FETCH_USER_PROFILE_ERROR'

export {
  APP,
  APP_PAGE_MOUNT,
  APP_PAGE_UNMOUNT,
  TOGGLE_NAVIGATION_DRAWER,
  FETCH_USER_PROFILE,
  FETCH_USER_PROFILE_START,
  FETCH_USER_PROFILE_SUCCESS,
  FETCH_USER_PROFILE_ERROR,
}
